<template>
  <aside class="filters filters-old-cars">
    <form action @submit.prevent="function () {}" class="car-filters-wrap">
      <div class="filters-top-wrap">
        <div class="filters-car-brand-wrap">
          <!-- <FilterBrands :brands="brands" :filters="filters" /> -->
<!--          <div v-if="!$device.tablet()" class="select-car-wrapper">
            <div class="select-car-type">
              <other-filter
                title="Hverju ertu að leita að?"
                :data="allFiltersData"
                :filters="filters"
                :all-filters-names="allFiltersNames"
                :filter_name="'all_filters'"
              />
            </div>
          </div>-->
          <FilterCarBodyTypes
              :filters="filters"
              isOldCars/>

          <div class="select-car-wrapper">
            <div class="select-car-type">
              <other-filter
                  class="select_tpl"
                  :title="
                  filters.brands.length > 0
                    ? 'Veldu framleiðenda'
                    : 'Allir framleiðendur'
                "
                  :data="brands"
                  :filters="filters"
                  :filter_name="'brands'"
              ></other-filter>
            </div>
          </div>
          <div
              style="padding-top: 0px"
              :class="['select-car-type', { hide: filters.brands.length == 0 }]"
          >
            <other-filter
                class="select_tpl"
                :title="
                filters.brand_model.length > 0 ? 'Veldu gerð' : 'Allar gerðir'
              "
                :data="brand_model"
                :sel="getOtheSelected(filters.brand_model, brand_model)"
                :filters="filters"
                :filter_name="'brand_model'"
            />
          </div>

          <div
              v-if="showCompanyFilter"
              style="padding-top: 0px"
              :class="['select-car-type']"
          >
            <!--                                :sel="getOtheSelected(filters.companies, companies)"-->
            <other-filter
                class="select_tpl"
                title="Companies"
                :data="$store.state.lib.old_cars_companies"
                :filters="filters"
                :filter_name="'companies'"
            />
          </div>
          <hr class="hr hr-table-hide"/>
        </div>
        <div class="filters-range-wrap">
          <div v-if="$device.tablet()" class="select-car-wrapper">
            <div class="select-car-type">
              <other-filter
                title="Hverju ertu að leita að?"
                :data="allFiltersData"
                :filters="filters"
                :all-filters-names="allFiltersNames"
                :filter_name="'all_filters'"
              />
            </div>
          </div>

          <template v-for="(item,index) in asideListFirstBlock">
            <form-ui-slider v-if="item.type === 'slider'"
                :key="index"
                :title="item.title"
                :name="item.name"
                :filters="filters"
                :params="getStartParams(item.name)"
                :unit="item.unit"
                :dots="item.dots"
            />
          </template>
<!--          <form-ui-slider
              :title="'Árgerð'"
              :name="'argerd'"
              :filters="filters"
              :params="{
              step: 0,
              min: parseInt(start_params.argerd.mi),
              max: parseInt(start_params.argerd.ma),
              start: filters.argerd,
            }"
              :dots="false"
          />
          <form-ui-slider
              :title="'Verð'"
              :name="'verd'"
              :filters="filters"
              :params="{
              step: 100000,
              min: parseInt(start_params.verd.mi),
              max: parseInt(start_params.verd.ma),
              start: filters.verd,
            }"
              :unit="'kr.'"
          />
          <form-ui-slider
              :title="'Akstur'"
              :name="'ekinn'"
              :filters="filters"
              :params="{
              step: 10000,
              min: parseInt(start_params.ekinn.mi),
              max: parseInt(start_params.ekinn.ma),
              start: filters.ekinn,
            }"
              :unit="'km.'"
          />-->
        </div>
      </div>
      <div class="aside-filters-padding">
        <hr class="hr"/>
      </div>
      <div class="filters-bottom-wrap">
        <div class="mobile-checkbox-wrap">
          <!-- <div>
                      <div class="checkbox-filters-wrap">
                        <label
                          v-for="(type, index) in fuel_type"
                          :for="type.name.toLocaleLowerCase()"
                          :key="index"
                          class="checkbox-filter-label"
                        >
                          <input
                            v-model="filters.fuel_type"
                            :value="type.id"
                            :id="type.name.toLocaleLowerCase()"
                            type="checkbox"
                          />
                          <span class="checkmark"></span>
                          <span class="checkbox-filter-hint">{{ type.name }}</span>
                          <span class="checkbox-filter-hint-count">{{ type.co }}</span>
                        </label>
                      </div>
                    </div> -->
          <div class="checkbox-filters-wrap">
            <label
                v-for="(type, index) in fuel_type"
                :for="type.name.toLocaleLowerCase()"
                :key="index"
                class="checkbox-filter-label"
            >
              <input
                  v-model="filters.fuel_type"
                  :value="type.id"
                  :id="type.name.toLocaleLowerCase()"
                  type="checkbox"
              />
              <span class="checkmark"></span>
              <span class="checkbox-filter-hint">{{ type.name }}</span>
              <span class="checkbox-filter-hint-count">{{ type.co }}</span>
            </label>
          </div>
          <div class="aside-filters-padding">
            <hr class="hr"/>
          </div>
          <div class="checkbox-filters-wrap">
            <!--                        <hr class="hr desctop-filters-hr"/>-->
            <!--                        <div class="checkbox-filters-wrap">-->
            <label
                v-for="(gi, index) in getGirartegund"
                :for="gi.id"
                :key="index"
                class="checkbox-filter-label"
            >
              <input
                  v-model="filters.girartegund"
                  type="checkbox"
                  :id="gi.id"
                  :value="index"
              />
              <span class="checkmark"></span>
              <span class="checkbox-filter-hint">{{ gi.name }}</span>
              <span class="checkbox-filter-hint-count">{{ gi.co }}</span>
            </label>
            <!--                        </div>-->
            <hr class="hr mobile-filters-hr"/>
            <hr class="hr desctop-filters-hr"/>
            <!-- <div class="checkbox-filters-wrap">
                          <label for="parking" class="checkbox-filter-label">
                            <input type="checkbox" v-model="filters.parking" id="parking" />
                            <span class="checkmark"></span>
                            <span class="checkbox-filter-hint">Á staðnum</span>
                            <img src="i/parking.png" alt width="21px" height="21px" />
                          </label>
                          <label for="sale" class="checkbox-filter-label">
                            <input type="checkbox" v-model="filters.verdtilbod" id="sale" />
                            <span class="checkmark"></span>
                            <span class="checkbox-filter-hint">Tilboðsbílar</span>
                            <img src="i/sale.png" alt width="21px" height="16px" />
                          </label>
                        </div> -->
            <label for="parking" class="checkbox-filter-label">
              <input type="checkbox" v-model="filters.parking" id="parking"/>
              <span class="checkmark"></span>
              <span class="checkbox-filter-hint">Á staðnum</span>
              <img :src="getHost+'/i/parking.png'" alt width="21px" height="21px"/>
            </label>
            <label for="sale" class="checkbox-filter-label">
              <input type="checkbox" v-model="filters.verdtilbod" id="sale"/>
              <span class="checkmark"></span>
              <span class="checkbox-filter-hint">Tilboðsbílar</span>
              <img :src="getHost+'/i/sale.png'" alt width="21px" height="16px"/>
            </label>

            <label for="sale" class="checkbox-filter-label">
              <input type="checkbox" v-model="filters.notInCountry" id="notInCountry"/>
              <span class="checkmark"></span>
              <span class="checkbox-filter-hint">Staðsett erlendis</span>
            </label>

            <label for="sale" class="checkbox-filter-label k7">
              <input type="checkbox" v-model="filters.k7" @change="changeK7" id="k7"/>
              <span class="checkmark"></span>
              <span class="checkbox-filter-hint">K7 bílasölur
                <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M11.4925 22.7003C17.68 22.7003 22.6855 17.6803 22.6855 11.5073C22.6855 5.33436 17.68 0.299683 11.4925 0.299683C5.30492 0.299683 0.299438 5.31976 0.299438 11.4927C0.299438 17.6657 5.31952 22.7003 11.4925 22.7003Z" fill="#DC5500"/>
                  <path d="M6.29728 10.2814L9.15756 6.77906H12.7913L9.2889 11.0111L13.0831 16.9943H9.43483L7.17287 13.419L6.29728 14.5135V16.9943H3.01379V6.76447H6.29728V10.2814Z" fill="white"/>
                  <path d="M20.5403 6.76447V9.39125L16.892 16.9797H13.3896L16.892 9.74149H13.0978V6.76447H20.5403Z" fill="white"/>
                </svg>
              </span>
            </label>

            <hr class="hr"/>
          </div>
        </div>
        <div v-for="(item,index) in asideList" :key="index" v-if="item.type === 'slider'" class="filters-range-wrap">
          <form-ui-slider
              class="big-unit50"
              :title="item.title"
              :name="item.name"
              :filters="filters"
              :params="getStartParams(item.name)"
              :unit="item.unit"
          />
        </div>

<!--            <div class="filters-range-wrap">
              <form-ui-slider
                  class="big-unit50"
                  :title="'Drægni'"
                  :name="'affinity'"
                  :filters="filters"
                  :params="getAffinity"
                  :unit="'km.'"
              />
            </div>
        <div class="filters-range-wrap">
              <form-ui-slider
                  class="big-unit60"
                  :title="'Dráttargeta'"
                  :name="'towing_capacity'"
                  :filters="filters"
                  :params="getCapacity"
                  :unit="'kg.'"
              />
          </div>-->
        <!-- <hr class="hr desctop-filters-hr" /> -->
        <div class="aside-filters-padding filters-extra">
          <!-- <div v-if="extra_type" class="owl-carousel owl-theme filters-slider-wrap">
                        <label
                                v-for="(f, index) in flokkar"
                                :for="'flokkar' + f.id"
                                :key="index"
                                class="filters-slider-card"
                        >
                            <input
                                    type="checkbox"
                                    v-model="filters.flokkar"
                                    :id="'flokkar' + f.id"
                                    :value="f.id"
                            />
                            <div class="filters-slider-card-mark">
                                <div
                                        class="filters-slider-card-img"
                                        style="background-image: url('/mock/cars.png');"
                                ></div>
                                <span>{{ f.name }}</span>
                            </div>
                        </label>
                    </div> -->

          <template v-for="(item,index) in asideList">
            <other-filter
                v-if="item.type === 'dropDown'"
                :key="index"
                :title="item.title"
                :data="getDataFromDropDown(item.lib)"
                :filters="filters"
                :filter_name="item.name"
            />
          </template>

          <other-filter
              v-for="(o, index) in other"
              :key="index"
              :title="index"
              :data="o"
              :filters="filters"
              :filter_name="'other'"
          />
          <!-- <hr class="hr mobile-filters-hide" /> -->
        </div>
      </div>
      <div v-show="false" class="filters-mobile-controls">
<!--        <button class="filters-mobile-extra-btn" type="button">
          <span>+ Opna</span> ítarleg leit
        </button>-->
        <div class="filters-mobile-results-wrap">
          <reset-filter v-if="$store.state.selected_filters_count > 0" class="filters-mobile-results-clear-btn">
            hreinsa síu
          </reset-filter>
<!--          <button
              v-if="$store.state.selected_filters_count > 0"
              class="filters-mobile-results-clear-btn"
              type="submit"
          >
            hreinsa síu
          </button>-->
          <button
              @click.prevent="scrollToRes"
              class="filters-mobile-results-btn"
              type="submit"
          >
            <span>{{ result_count }}</span>
            niðurstöður
          </button>
        </div>
        <button
            v-if="$store.state.selected_filters_count"
            @click.prevent="scrollToTop"
            class="filters-mobile-filters-btn"
        >
          <span>{{ $store.state.selected_filters_count }} skilyrði</span>
          <svg viewBox="0 0 21 25" width="21px" height="25px">
            <g
                fill="none"
                fill-rule="evenodd"
                stroke="#FFF"
                stroke-linecap="round"
                stroke-linejoin="round"
                transform="rotate(90 9.5 10.5)"
            >
              <path
                  d="M9 2.5h14M0 2.5h4M18 9.5h5M0 9.5h13M10 16.5h13M0 16.5h5"
              />
              <circle cx="6.5" cy="2.5" r="2.5"/>
              <circle cx="15.5" cy="9.5" r="2.5"/>
              <circle cx="7.5" cy="16.5" r="2.5"/>
            </g>
          </svg>
        </button>

      </div>
      <div class="aside_div_bottom" :style="{height: `${$device.android() ? 150 : 80}px`}"></div>
    </form>
  </aside>
</template>

<script>
import FilterBrands from "@/components/OldCars/FilterBrands.vue";
import FormUiSlider from "@/components/FormUiSlider.vue";
import OtherFilter from "@/components/OtherFilter.vue";
import FilterCarBodyTypes from "@/components/Filters/СarBodyTypes";
import ResetFilter from "@/components/ResetFilter";
import getBaseUrl from "@/helpers/getBaseUrl";
import {mapGetters, mapState} from "vuex";
import axios from "axios";

export default {
  components: {
    FilterBrands,
    FormUiSlider,
    OtherFilter,
    FilterCarBodyTypes,
    ResetFilter
  },
  props: [
    "brands",
    "brand_model",
    "fuel_type",
    "girartegund",
    "flokkar",
    "vehicle_type",
    "extra_type",
    "result_count",
    "filters",
    "dataCarsLoaded",
  ],
  data: () => ({
    k7:true,
    count: 0,
    init: true,
    owl: null,
    start_params: null,
    allFiltersNames: ['brands', 'companies', 'fuel_type', 'girartegund', 'flokkar', 'other'],
    allFiltersData: []
  }),
  methods: {
    async getAllFiltersData() {
      let all = []

      if (this.brands.length) {
        axios.post(`${getBaseUrl()}/api/old-cars/index?imported=1&skipHistory=1`,
          {
            filters: {brands: this.brands.map(brand => brand.id)},
            all: false,
            sort: {
              field: "",
              order: ""
            },
            alc: null,
            withMainImg: true,
            imported: 0
          }
        )
          .then(({data}) => {
            let brandsWithModels = this.otherSliderRefactor(data.brand_model)
            brandsWithModels.forEach(a => {
              if (a.model_class) a.filter_name = 'models_id'
            })

            all = all.concat(
                    this.collectAllFiltersItem(brandsWithModels, 'brands', 'Allir framleiðendur'),
                    this.collectAllFiltersItem(this.$store.state.lib.old_cars_companies, 'companies', 'Bílaumboð'),
                    this.collectAllFiltersItem(this.fuel_type, 'fuel_type', 'Eldsneyti'),
                    this.collectAllFiltersItem(this.getGirartegund, 'girartegund', 'Girartegund'),
                    this.collectAllFiltersItem(this.mapCategories, 'flokkar', 'Stærð og gerð'),
                    this.collectAllFiltersItem(this.other, 'other'),
            )

            this.allFiltersData = all;
          })
      }
    },
    updExtra: function () {
      window.extraType = false;
    },
    isBrand: function (id) {
      return this.filters.brands[id];
    },
    getOtheSelected: function (filter, other) {
      let res = [];
      for (let k in other) {
        let item = other[k];
        if (filter.indexOf(item.id) >= 0) {
          res.push(item);
        }
      }
      return res;
    },
    scrollToRes() {
      this.$scrollTo(".results-cards-wrap", 1000, {offset: -110});
    },
    scrollToTop() {
      this.$scrollTo(".car-filters-wrap", 1000, {offset: -110});
    },
    changeK7(){
      if(this.filters.k7 && this.$route.name == 'OldCars'){
        this.$router.push({name:'k7Cars'});
      }

      if(!this.filters.k7 && this.$route.name == 'k7Cars'){
        this.$router.push({name:'OldCars'});
      }
    },
    collectAllFiltersItem(data, filterName, groupLabel) {
      let newData = []
      if (data && Array.isArray(data) && data.length) {
        newData = JSON.parse(JSON.stringify(data))
        newData.unshift({ name: groupLabel, isLabel: true })
        newData.forEach(item => item.filter_name = item.bid ? 'brand_model' : filterName)
      } else if (data && !Array.isArray(data)) {
        for (let [key, value] of Object.entries(JSON.parse(JSON.stringify(data)))) {
          value.forEach(f => f.filter_name = 'other')
          newData.push({ name: key, isLabel: true }, ...value)
        }
      }
      return newData
    },
    otherSliderRefactor: function (arr) {
      for (let k in arr) {
        if (arr[k].disable && this.brands.length) {
          arr[k] = this.brands.find(brand => brand.name === arr[k].name)
        } else if (arr[k].model_class) {
          arr[k].name = arr[k].model_class;
        }
      }
      return arr;
    },
    getStartParams(paramKey) {
      const curParam = this.oldCarsStartParams[paramKey];
      let start = [curParam.min,curParam.max];

      if (this.filters[paramKey] && this.filters[paramKey].length > 0){
        if(this.filters[paramKey][0]){
          start[0] = this.filters[paramKey][0];
        }else{
          this.filters[paramKey][0] = curParam.min;
        }

        if(this.filters[paramKey][1]){
          start[1] = this.filters[paramKey][1];
        }else{
          this.filters[paramKey][1] = curParam.max;
        }
      }

      return {
        min: curParam.min,
        max: curParam.max,
        start: start,
        step:curParam.step || 1
      };
    },
    getDataFromDropDown(key){
      return this.lib[key];
    },
  },
  mounted() {
    document.body.classList.add("js-show-filters");
  },
  created() {
    this.start_params = this.oldCarsStartParams;
  },
  /* updated() {
          if (this.init) {
            setTimeout(() => {
              var owl = $(".owl-carousel.filter-car-type").owlCarousel({
                margin: 15,
                autoWidth: true
              });

              owl.trigger("refresh.owl.carousel");
            }, 1000);
            this.init = false;
          }
        }, */
  watch: {
    brands: {
      immediate: true,
      handler() {
        this.getAllFiltersData()
      },
      deep: true,
    },
  },
  computed: {
    ...mapGetters({lib: 'LIB'}),
    ...mapState('moduleOldCars', {
      asideList: state => state.asideList,
      asideListFirstBlock: state => state.asideListFirstBlock,
      oldCarsStartParams: state => state.startParams
    }),
    /*getAffinity(){
      const startAffinity = this.oldCarsStartParams.affinity;
      let start = [startAffinity.min,startAffinity.max];


      if (this.filters.affinity&&this.filters.affinity.length > 0){
        if(this.filters.affinity[0]){
          start[0] = this.filters.affinity[0];
        }else{
          this.filters.affinity[0] = startAffinity.min;
        }

        if(this.filters.affinity[1]){
          start[1] = this.filters.affinity[1];
        }else{
          this.filters.affinity[1] = startAffinity.max;
        }
      }

      return {
        min: startAffinity.min,
        max: startAffinity.max,
        start: start,
        step:10
      };
    },
    getCapacity(){
      const towing_capacity = this.oldCarsStartParams.towing_capacity;
      let start = [towing_capacity.min,towing_capacity.max];


      if (this.filters.towing_capacity&&this.filters.towing_capacity.length > 0){
        if(this.filters.towing_capacity[0]){
          start[0] = this.filters.towing_capacity[0];
        }else{
          this.filters.towing_capacity[0] = towing_capacity.min;
        }

        if(this.filters.towing_capacity[1]){
          start[1] = this.filters.towing_capacity[1];
        }else{
          this.filters.towing_capacity[1] = towing_capacity.max;
        }
      }

      return {
        min: towing_capacity.min,
        max: towing_capacity.max,
        start: start,
        step:10
      };
    },*/
    mapCategories() {
      if (this.lib && this.lib.flokkar) {
        const array = [];
        for (const key in this.lib.flokkar) {
          if (Object.hasOwnProperty.call(this.lib.flokkar, key)) {
            array.push({
              id: this.lib.flokkar[key].id,
              name: this.lib.flokkar[key].name,
            });
          }
        }
        return array;
      }
      return [];
    },
    showCompanyFilter() {
      return location.host !== "bilaskra.is";
      //return process.env.NODE_ENV === 'development';
    },
    dataOldCarsLoaded() {
      return this.$store.getters.moduleOldCars.oldCarsLoaded;
    },
    getHost(){
      return getBaseUrl();
    },
    getGirartegund() {
      let res = [];
      for (let k in this.$store.state.lib.girartegund) {
        let item = this.$store.state.lib.girartegund[k];
        item.co = this.girartegund[k] ? this.girartegund[k].co : 0;
        // this.girartegund[k].name = this.$store.state.lib.girartegund[this.girartegund[k].g].name;
        res.push(item);
      }
      return res;
    },
    other(){
      return this.lib && this.lib.other;
    },
  },
};
</script>
